export const TypeOptions = 
[{ value: "Rental", label: "Rental" }, 
{ value: "Food", label: "Food" }, 
{ value: "Utility", label: "Utility" }, 
{ value: "Travel", label: "Travel"},
{ value: "Other", label: "Other (Please Specify)" }];